import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const FilterBridgeContext = createContext(null);

export function FilterBridgeProvider({ children }) {
  const [sharedFilters, setSharedFilters] = useState(null);
  const [pageFilters, setPageFilters] = useState(null);

  const registerShared = useCallback((config) => {
    setSharedFilters(config);
  }, []);

  const registerPage = useCallback((config) => {
    setPageFilters(config);
  }, []);

  const clearPage = useCallback(() => {
    setPageFilters(null);
  }, []);

  const filters = useMemo(() => {
    if (!sharedFilters && !pageFilters) return null;
    return { ...sharedFilters, ...pageFilters };
  }, [sharedFilters, pageFilters]);

  const value = useMemo(
    () => ({ filters, registerShared, registerPage, clearPage }),
    [filters, registerShared, registerPage, clearPage]
  );

  return <FilterBridgeContext.Provider value={value}>{children}</FilterBridgeContext.Provider>;
}

export function useFilterBridge() {
  const ctx = useContext(FilterBridgeContext);
  if (!ctx) throw new Error('useFilterBridge must be used within FilterBridgeProvider');
  return ctx;
}

export function useRegisterSharedMenuFilters(config) {
  const { registerShared } = useFilterBridge();

  useEffect(() => {
    if (config) registerShared(config);
  }, [config, registerShared]);
}

export function useRegisterMenuFilters(active, config) {
  const { registerPage, clearPage } = useFilterBridge();

  useEffect(() => {
    if (!active) {
      clearPage();
    }
    return () => clearPage();
  }, [active, clearPage]);

  useEffect(() => {
    if (active && config) {
      registerPage(config);
    }
  }, [active, config, registerPage]);
}
